import React, { useEffect, useContext, useReducer } from 'react';
import { store as reportStore } from '../reducer';
import { useHistory, Switch, Route } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Filters from './Filters';
import List from './List';
import { store, initialState, reducer } from './reducer';
import moment from 'moment-jalaali';
import axios from '../../../../../api/axios';
import useTitle from 'hooks/useTitle';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridGap: theme.spacing(1),
  },
}));

const InsuranceExpiry = () => {
  useTitle('گزارش بیمه نامه ها');
  const classes = useStyles();
  const parentUrl = `/protected/admin/reports/insuranceExpiry`;
  const {
    state: reportState,
    dispatch: reportDispatch,
    showMessage,
    showError,
    itemsCountPerPage,
  } = useContext(reportStore);

  const mkState = (state) => {
    const start = moment().startOf('jDay');
    const end = moment().add(7, 'days').endOf('jDay');
    return { ...state, filters: { start, end } };
  };

  const [state, dispatch] = useReducer(reducer, initialState, mkState);
  const { Provider } = store;
  const {
    filters: { start, end },
    page,
  } = state;
  const history = useHistory();
  const {
    location: { pathname },
  } = history;

  const fetchReport = async () => {
    try {
      const { data } = await axios.post(
        `/api/v1/admin/users/list/drivers/insuranceExpiry`,
        {
          start,
          end,
          page,
          limit: itemsCountPerPage,
        }
      );
      data?.ok && dispatch({ type: 'REPORT', payload: data?.report });
    } catch (error) {
      showError(error);
    }
    dispatch({ type: 'PROGRESS', payload: false });
  };

  useEffect(() => {
    pathname === parentUrl &&
      reportDispatch({
        type: 'CHANGE_TITLE_CATEGORY',
        payload: {
          title: 'گزارش بیمه‌نامه های سررسید شده',
          category: 'گزارش بیمه نامه ناوگان‌هایی که در رنج مشخص سر رسید میشوند',
        },
      });
  }, [pathname]);
  useEffect(() => {
    dispatch({ type: 'PROGRESS', payload: true });
    fetchReport();
  }, [start, end, page]);

  return (
    <Provider
      value={{ state, dispatch, itemsCountPerPage, showMessage, showError }}
    >
      <Switch>
        <Route exact path={`${parentUrl}`}>
          <div className={classes.root}>
            <Filters />
            <List />
          </div>
        </Route>
      </Switch>
    </Provider>
  );
};

export default React.memo(InsuranceExpiry);
